import testData from "@/shared/testData.js";
import {
  Report,
  Template,
  ReportState,
  Mutations,
  Actions,
  SearchCondition,
  UpdateReportParam} from "@/types/entities.ts";
import ReportClient from "@/store/service/reportClient.ts";
import $router from "@/router";

const state: ReportState = {
  openTemplateModal: false,
  reports: [],
  reportGroups: [],
  reportLabels: [],
  searchCondition: {
    group: "",
    keyword: "",
  },
};

const mutations: Mutations = {
  openTemplateModal: (state) => {
    state.openTemplateModal = true;
  },
  closeTemplateModal: (state) => {
    state.openTemplateModal = false;
  },
  getReports: (state, groups) => {
    state.reportGroups = groups;
  },
  createdNewReport: (state, group: Report) => {
    // Typescriptで書き直す必要がある
    state.reportGroups = state.reportGroups.concat([group]);
    // state.reportGroups.push(group);
  },
  updateReport: (state, reports: Report[]) => {
    // const dummy: Report[] = [];
    // const newReportGroups: Report[] = dummy.concat(state.reportGroups);
    // state.reportGroups = newReportGroups;
    state.reportGroups = reports;
  },
  getTemplates: (state, reports) => {
    state.reports = reports;
  },
  updateTemplates: (state, reports: Template[]) => {
    state.reports = reports;
  },
  getTemplateGroups: (state, groups) => {
    state.reportLabels = groups;
  },
  updateReportLabels: (state, labels) => {
    state.reportLabels = labels;
  },
  updateSearchCondition: (state, condition: SearchCondition) => {
    state.searchCondition = condition;
  },
};

const getters = {
  currentReportInfo: (state: ReportState) => {
    const { params } = $router.currentRoute;
    for (let i = 0; state.reportGroups.length; i++) {
      const element: Report = state.reportGroups[i];
      if (params.group_id && params.group_id === element.report_id) {
        return element;
      }
    }
    return null;
  },
};

const actions: Actions = {
  /*
    最上位の概念 レポート
    TODO: 異常系
  */
  getReports: ({commit}) => {
    return new Promise((resolve, reject) => {
      ReportClient.getReports()
      .then((reports) => {
        commit("getReports", reports);
        resolve(reports);
      })
      .catch((err) => {
        reject(err);
      });
    });
  },

  /*
    新規レポート作成
    TODO: token(これはサーバ側で生成してもらうほうが良い)
    TODO: 異常系
  */
  createNewReportGroup: ({commit}, name) => {
    return new Promise((resolve, reject) => {
      ReportClient.createReport(name)
      .then((report) => {
        commit("createdNewReport", report);
        resolve(report);
      })
      .catch((err) => {
        console.log(err);
        reject(err);
      });
    });
  },

  /*
    レポートの更新
    @param params
      {
        report_id: string,
        report_name: string,
        token_reacreate: boolean
      }
    token_reacreate が true の場合はtokenを再作成する
    TODO: token は新規同様検討
    TODO: 異常系
  */
  updateReport: ({commit, state}, params) => {
    return new Promise((resolve, reject) => {
      const newReport: UpdateReportParam = {
        reportId: params.report_id,
        reportName: params.report_name,
        isUpdateToken: params.tokenRecreate,
      };
      ReportClient.updateReport(newReport)
      .then((allReports) => {
        commit("updateReport", allReports);
        resolve(allReports);
      })
      .catch((err) => {
        reject(err);
      });
    });
  },

  /*
    レポートの削除
    @param reportId: string,
    TODO: 異常系
  */
  deleteReport: ({commit, state}, reportId) => {
    return new Promise((resolve, reject) => {
      ReportClient.deleteReport(reportId)
      .then((allReports) => {
        commit("updateReport", allReports);
        resolve(allReports);
      })
      .catch((err) => {
        reject(err);
      });
    });
  },

  /*
    帳票テンプレート(レポートの中にある一覧)の取得
    @param reportId: レポートのID

    group は取得した一覧から無理やり撮っているが、本当は専用のAPIによる取得があるべき
  */
  getTemplates: ({commit}, reportId) => {
    return new Promise((resolve, reject) => {
      // テーブルの一覧に変なのが見えないように
      commit("getTemplates", [{
        id: "",
        name: "",
        group: "",
        update_date: "",
      }]);
      ReportClient.getTemplates(reportId)
      .then((templates) => {
        // @ts-ignore
        const groups: Set<string> = new Set(templates.map((i) => i.group));
        commit("getTemplates", templates);

        // TODO: 本当は専用の取得APIがある？
        commit("getTemplateGroups", Array.from(groups));
        resolve(templates);
      })
      .catch((err) => {
        reject(err);
      });
    });
  },

  /*
    帳票テンプレートの新規追加(アップロード)
    @params uploadInfo
      reportId: upload 先のレポート
      submitInfo: name/group/file がまとまったオブジェクトの配列
    TODO: 今は1つだけ
  */
  createNewTemplates: ({dispatch}, uploadInfo) => {
    return new Promise((resolve, reject) => {
      console.log(uploadInfo);
      const { reportId, submitInfo } = uploadInfo;
      ReportClient.createTemplate(reportId, submitInfo[0])
      .then((templateId) => {
        // 今は全更新
        dispatch("getTemplates", reportId);
        resolve(templateId);
      })
      .catch((err) => {
        reject(err);
      });
    });
  },

  /*
    帳票テンプレートの更新(アップロード)
    @params uploadInfo
      reportId: upload 先のレポート
      submitInfo: name/group/file がまとまったオブジェクト
  */
  updateTemplate: ({dispatch}, uploadInfo) => {
    return new Promise((resolve, reject) => {
      console.log(uploadInfo);
      const { reportId, templateId, submitInfo } = uploadInfo;
      ReportClient.updateTemplate(reportId, templateId, submitInfo)
      .then((templateId) => {
        // 今は全更新
        dispatch("getTemplates", reportId);
        resolve(templateId);
      })
      .catch((err) => {
        reject(err);
      });
    });
  },

  /*
    帳票テンプレートの削除
    @params deleteInfo
      reportId: delete 先のレポート
      templateIds: 削除するテンプレートのid配列
    TODO: 今は1つだけ
  */
 deleteTemplates: ({commit, state}, deleteInfo) => {
  return new Promise((resolve, reject) => {
    console.log(deleteInfo);
    const { reportId, templateIds } = deleteInfo;
    ReportClient.deleteTemplates(reportId, templateIds)
    .then(() => {
      const remainTemplates = state.reports.filter((r) => !(templateIds.includes(r.id)));
      commit("updateTemplates", remainTemplates);
      resolve();
    })
    .catch((err) => {
      console.log(err);
      reject(err);
    });
  });
},

changeSearchCondition({commit}, condition: SearchCondition) {
  return new Promise((resolve, reject) => {
    commit("updateSearchCondition", condition);
    resolve();
  });
},

////////////////////////////////////////////////////
// 帳票テンプレートに付与するグループ(つけられるのは1つだけ？)
  getReportLabels: ({commit}, groupId) => {
    return new Promise((resolve, reject) => {
      setTimeout(() => {
        // commit("getReportLabels", testData.reportLabels[groupId]);
        resolve();
      }, 300);
    });
  },

  updateReportLabels: ({commit}, params) => {
    return new Promise((resolve, reject) => {
      setTimeout(() => {
        testData.reportLabels[params.groupId] = params.labels;
        commit("updateReportLabels", params.labels);
        resolve();
      }, 300);
    });
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
